import React from 'react';
import { Icon } from './Icon.js';
export const IconLockOpen2 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M1 6C1 3.79086 2.79086 2 5 2C7.20914 2 9 3.79086 9 6V10", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M3 10H21V21H3V10Z", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M12 15V16", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconLockOpen2.js.map